import { render } from "./ActivityPage0727.vue?vue&type=template&id=b37e0d82&scoped=true"
const script = {}

import "./ActivityPage0727.vue?vue&type=style&index=0&id=b37e0d82&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37e0d82"]])

export default __exports__